import React from 'react'
import { ConfirmationRoleAction } from '../../../legacy-design-system/action'
import {
  DeleteDialog,
  DeleteBulkDialog,
  DeleteBulkWithFiltersDialog
} from './delete-dialog'
import {
  ServerActionProps,
  ServerBulkActionProps,
  ServerBulkActionWithFiltersProps
} from './row-action-list'
import { Role } from '@contrast-security-inc/base-types'
import { Placement } from '../../../legacy-design-system/popper'
import { IconDelete } from '@contrast-security-inc/design-system-foundations'

const commonProps = (serverName?: string) => ({
  requiredRole: 'ADMIN' as Role,
  icon: IconDelete,
  iconTooltipMessage: {
    id: `action_delete${serverName ? '_' + serverName : ''}`,
    defaultMessage: 'Delete'
  },
  iconTooltipPlacement: 'top' as Placement,
  'data-testid': `action_delete${serverName ? '_' + serverName : ''}`
})

export function DeleteAction(props: ServerActionProps) {
  const {
    server: { name: serverName }
  } = props
  return (
    <ConfirmationRoleAction
      size={props.size}
      isActionValid={!props.isFreemium}
      role={props.organizationRole}
      renderDialog={(renderDialogProps) => {
        return <DeleteDialog {...props} {...renderDialogProps} />
      }}
      {...commonProps(serverName)}
    />
  )
}

export function DeleteBulkAction(props: ServerBulkActionProps) {
  return (
    <ConfirmationRoleAction
      size={props.size}
      isActionValid={!props.isFreemium}
      role={props.organizationRole}
      renderDialog={(renderDialogProps) => {
        return <DeleteBulkDialog {...props} {...renderDialogProps} />
      }}
      {...commonProps()}
    />
  )
}

export function DeleteBulkWithFiltersAction(
  props: ServerBulkActionWithFiltersProps
) {
  return (
    <ConfirmationRoleAction
      size={props.size}
      isActionValid={!props.isFreemium}
      role={props.organizationRole}
      renderDialog={(renderDialogProps) => {
        return <DeleteBulkWithFiltersDialog {...props} {...renderDialogProps} />
      }}
      {...commonProps()}
    />
  )
}
